/**
 * Single source for the expanded single-column sidebar width, shared by the app
 * shell (MainContentArea, as the `--sidebar-w` value) and the standalone
 * professional-directory rail (DirectoryNavRail) so the two can't silently
 * drift. Narrower for anonymous users (fewer rows, no footer).
 */
export const SIDEBAR_EXPANDED_WIDTH_AUTH = '300px';
export const SIDEBAR_EXPANDED_WIDTH_ANON = '280px';
